import styled from '@emotion/styled';
import { Button } from 'src/domains/layouts/webview/components/common/button/Button';
import { withConfig } from 'src/withConfig';

export const CenteredVerifyHeadline = withConfig(theme => styled('h3', { label: 'CenteredVerifyHeadline' })`
    margin: 0 0 8px 0 !important;
    font-size: ${theme.star.fontSize.xMedium} !important;
    font-weight: ${theme.star.fontWeight.bold} !important;
    line-height: 1.4;
`);

export const VerifyInfo = withConfig(theme => styled('p', { label: 'VerifyInfo' })`
    margin: 0 0 16px 0;
    font-size: ${theme.star.fontSize.xRegular};
    font-weight: ${theme.star.fontWeight.regular};
    line-height: 1.43 !important;
`);

export const VerifyInfoExtra = styled(VerifyInfo, { label: 'VerifyInfoExtra' })`
    margin: 8px 0;
`;

export const VerifyInfoSuspendedCentered = styled(VerifyInfo, { label: 'VerifyInfoSuspendedCentered' })`
    margin: 10px auto 0;
`;

export const VerifyInfoGamStop = styled(VerifyInfo, { label: 'VerifyInfoGamStop' })`
    margin: 0 4px 12px;
`;

const YellowButton = styled(Button, { label: 'YellowButton' })`
    width: 100%;
    text-transform: capitalize;
`;

export const VerifyButton = styled(YellowButton, { label: 'VerifyButton' })`
    margin: 24px 0 0 0 !important;
`;

export const HomeButtonWrapper = styled(YellowButton, { label: 'HomeButtonWrapper' })`
    margin: 56px 0 0 0;
`;
